export default __webpack_public_path__ + "static/Calendar-9edd480d752a3a3f60bda2ab883359c8.svg";